export default __webpack_public_path__ + "static/media/placeholder_dummy2016-zahnarzt01-mobile-de.db5bb9df.png";